import React from "react";

const PrivacyPolicy = () => {
  return (
    <section className="lg:min-h-[670px] md:min-h-[780px] sm:min-h-[515px]  text-whiteee lg:px-2 md:px-4 sm:px-4">
      <div className="max-w-[1280px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12">
        <div className="flex justify-center items-center mb-4">
          <h2 className="lg:text-5xl md:text-3xl sm:text-3xl text-center lg:px-0 md:px-0 sm:px-4  font-extrabold tracking-tighter text-golden">
            Privacy Policy
          </h2>
        </div>

        <div className="text-sm leading-relaxed">
          <p className="mb-4 text-whiteee">
            Effective Date: <span className="text-golden">[16-05-2025]</span>
          </p>

          <p className="mb-4">
            WristLink ("Company," "we," "us," or "our") respects your privacy
            and is committed to protecting your personal data. This Privacy
            Policy outlines how we collect, use, disclose, and safeguard your
            information when you interact with our services, including our
            website, applications, and communications. Please read this policy
            carefully to understand our practices regarding your personal data.
          </p>

          <h3 className="text-golden font-bold mb-2">
            1. Information We Collect
          </h3>
          <p className="mb-4">
            We may collect and process the following types of information:
          </p>

          <div className="relative pl-4">
            <div className="absolute inset-0 left-0 w-[1px] bg-gradient-to-b from-primary via-golden to-primary"></div>

            <div className="ml-4">
              <h4 className="text-golden font-bold mb-2">
                1.1 Personal Information
              </h4>
              <ul className="list-disc list-inside mb-4">
                <li>
                  Name, contact details (email address, phone number, address)
                </li>
                <li>
                  Identification documents (if required for compliance or
                  transactions)
                </li>
                <li>Payment and transaction details</li>
              </ul>

              <h4 className="text-golden font-bold mb-2">
                1.2 Non-Personal Information
              </h4>
              <ul className="list-disc list-inside mb-4">
                <li>IP address, browser type, and operating system</li>
                <li>
                  Usage data, such as website navigation and interaction details
                </li>
                <li>Preferences and settings on our platforms</li>
              </ul>

              <h4 className="text-golden font-bold mb-2">
                1.3 Sensitive Information
              </h4>
              <p className="mb-4">
                Compliance-related information as required under Anti-Money
                Laundering (AML) or Know Your Customer (KYC) regulations.
              </p>
            </div>
          </div>

          <h3 className="text-golden font-bold mb-2">
            2. How We Use Your Information
          </h3>
          <ul className="list-disc list-inside mb-4">
            <li>To provide our services and process your transactions</li>
            <li>
              To comply with legal and regulatory requirements (e.g., AML/KYC
              compliance)
            </li>
            <li>To improve our website, applications, and customer service</li>
            <li>
              To send updates, notifications, and promotional materials (with
              your consent)
            </li>
            <li>To monitor and analyze trends and usage patterns</li>
          </ul>

          <h3 className="text-golden font-bold mb-2">
            3. Sharing Your Information
          </h3>
          <p className="mb-4">
            We do not sell, trade, or rent your personal information to others.
            However, we may share your information with trusted third parties
            for the following reasons:
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>
              <span className="text-golden">Service Providers:</span> For
              payment processing, IT support, and other operational services.
            </li>
            <li>
              <span className="text-golden">Regulatory Authorities:</span> When
              required by law or to comply with legal obligations.
            </li>
            <li>
              <span className="text-golden">Business Partners:</span> For
              collaborative projects or initiatives, with your consent.
            </li>
          </ul>

          <h3 className="text-golden font-bold mb-2">4. Data Security</h3>
          <p className="mb-4">
            We implement robust security measures to protect your personal data
            from unauthorized access, alteration, disclosure, or destruction.
            These include:
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>Secure servers and encryption for sensitive data</li>
            <li>Regular system monitoring and updates</li>
            <li>
              Access control policies to restrict data handling to authorized
              personnel
            </li>
          </ul>

          <h3 className="text-golden font-bold mb-2">5. Your Rights</h3>
          <p className="mb-4">
            Depending on your jurisdiction, you may have the following rights:
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>Access: Request access to your personal data held by us.</li>
            <li>
              Correction: Request correction of inaccurate or incomplete data.
            </li>
            <li>
              Deletion: Request deletion of your personal data (subject to legal
              requirements).
            </li>
            <li>Objection: Object to certain processing activities.</li>
            <li>
              Data Portability: Request transfer of your data to another service
              provider.
            </li>
          </ul>
          <p className="mb-4">
            To exercise your rights, please contact us at{" "}
            <span className="text-golden">info@wristlink.app</span>.
          </p>

          <h3 className="text-golden font-bold mb-2">
            6. Cookies and Tracking
          </h3>
          <p className="mb-4">
            We may use cookies and similar technologies to enhance your browsing
            experience. Cookies help us analyze website traffic, store user
            preferences, and improve functionality. By using our website, you
            consent to the use of cookies.
          </p>
          <p className="mb-4">
            You can manage or disable cookies through your browser settings.
            However, disabling cookies may affect website functionality.
          </p>

          <h3 className="text-golden font-bold mb-2">7. Third-Party Links</h3>
          <p className="mb-4">
            Our website or applications may include links to third-party
            websites. We are not responsible for the privacy practices or
            content of these external sites. We encourage you to review their
            privacy policies.
          </p>

          <h3 className="text-golden font-bold mb-2">8. Data Retention</h3>
          <p className="mb-4">
            We retain your personal data only as long as necessary to fulfill
            the purposes outlined in this policy or to comply with legal
            obligations.
          </p>

          <h3 className="text-golden font-bold mb-2">
            9. Compliance with International Regulations
          </h3>
          <p className="mb-4">
            As a company operating in the United Arab Emirates, we adhere to all
            applicable data protection and privacy regulations, including those
            relevant to the gold trading industry.
          </p>

          <h3 className="text-golden font-bold mb-2">
            10. Updates to This Privacy Policy
          </h3>
          <p className="mb-4">
            We may update this Privacy Policy periodically to reflect changes in
            our practices or applicable laws. Any changes will be posted on this
            page, and significant updates may be communicated directly to you.
          </p>

          <p className="text-whiteee mt-12">
            This Privacy Policy is designed to build trust and transparency with
            our customers and stakeholders. By continuing to use our services,
            you agree to the terms outlined in this policy.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
